import React from 'react';
import './svg.css';

const WhiteRightArrow = () => {
  return (

    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M16.7502 10.3125L4 10.3125M16.7502 10.3125L11.4376 5M16.7502 10.3125L11.4376 15.6251" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default WhiteRightArrow;